import { createEnum } from '../utils/enums'
import { getUserId } from './users'

export const SignatoryStatus = createEnum(
  {
    AwaitingSignature: 'Awaiting_Signature',
    Signed: 'Signed',
    Declined: 'Declined'
  },
  'SignatoryStatus'
)

export function getPartySignatory({ signatories }, user) {
  const userIdToLookFor = getUserId(user)
  return signatories.find(({ userId }) => userId === userIdToLookFor)
}

export function getCounterPartyNames(document) {
  return document.counterParties.map(({ name }) => name).join(', ')
}

export function createCounterPartiesData(users) {
  return Object.values(
    users.reduce((acc, { accountId, id }) => {
      if (!acc[accountId]) {
        acc[accountId] = {
          accountId,
          signatoryIds: []
        }
      }
      acc[accountId].signatoryIds.push(id)
      return acc
    }, {})
  )
}

export function getSignatories(parties) {
  return parties.flatMap(({ signatories }) => signatories)
}
